import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Four04 } from 'gossamer-front-end';
import { InboxPage } from './InboxPage';

export const ConvoRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/inbox/:convoId?" element={<InboxPage />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
